import ButtonIconGhostMedium from '../../../../components/common/ButtonIconGhost/ButtonIconGhostMedium';
import ButtonIconGhostSmall from '../../../../components/common/ButtonIconGhost/ButtonIconGhostSmall';
import Slider from '../../../../components/common/Slider/Slider';
import { Icon } from '../../../../components/icon/icon';
import './SliderDesign.scss';

const SliderDesign = () => {
  return (
    <div className="slider-design flex absolute items-center gap-8 top-0 left-0">
      <ButtonIconGhostMedium
        icon={<Icon.ICUndo />}
        className={'custom-button'}
      />
      <ButtonIconGhostMedium
        icon={<Icon.ICRedo />}
        className={'custom-button'}
      />
      <div className="slider flex px-8 py-12 items-center h-32 gap-8 rounded-[100px]">
        <ButtonIconGhostSmall icon={<Icon.ICRemove />} />
        <Slider style={{ width: '114px' }} />
        <ButtonIconGhostSmall icon={<Icon.ICAdd />} />
      </div>
    </div>
  );
};

export default SliderDesign;
